import { WindowManager } from '@kurtosys/window-manager';
import { SourceEventManager } from './SourceEventManager.js';
export class EventManager {
    constructor() {
        this.sources = new Map();
    }
    getSource(sourceKey) {
        return this.sources.get(sourceKey);
    }
    addSource(sourceKey) {
        const sourceManager = new SourceEventManager(sourceKey);
        if (!this.sources.has(sourceManager.key)) {
            this.sources.set(sourceManager.key, sourceManager);
        }
    }
    subscribe(sourceKey, subscription) {
        let sourceManager = this.getSource(sourceKey);
        // create if the publisher hasn't created it yet, it is safe to assume the publish will simply re-use this source when it has initialised.
        if (!sourceManager) {
            this.addSource(sourceKey);
            sourceManager = this.getSource(sourceKey);
        }
        sourceManager.subscribe(subscription);
    }
    unsubscribe(sourceKey, type, listener) {
        const sourceManager = this.getSource(sourceKey);
        // if the source doesn't exist, it is not needed to remove the listener as it doesn't exist.
        if (sourceManager) {
            sourceManager.unsubscribe(type, listener);
        }
    }
    publish(sourceKey, source, detail) {
        let sourceManager = this.getSource(sourceKey);
        if (!sourceManager || sourceManager.getSubscribers(detail.type).length <= 0) {
            const workingSourceKey = SourceEventManager.generateKey(source, true);
            sourceManager = this.getSource(workingSourceKey);
        }
        // if the publisher hasn't already created the source, create it now.
        if (!sourceManager) {
            this.addSource(sourceKey);
            sourceManager = this.getSource(sourceKey);
        }
        sourceManager.publish(source, detail);
    }
    static init() {
        if (!WindowManager.has(EventManager.key)) {
            WindowManager.set(EventManager.key, new EventManager());
        }
    }
    static destroy() {
        const manager = WindowManager.get(EventManager.key);
        if (manager) {
            manager.sources.clear();
            WindowManager.set(EventManager.key, undefined);
        }
    }
    static get() {
        if (!WindowManager.has(EventManager.key)) {
            console.error(`${EventManager.key} instance not found!`);
            return;
        }
        return WindowManager.get(EventManager.key);
    }
}
EventManager.key = 'EventManager';
//# sourceMappingURL=EventManager.js.map